import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import allActions from '../../actions/index';

function MobileTopAds() {    
    var TopADV = "";
    
    const mobile_top = useSelector((state) => state.HomeBucket.bucket.data.ads.mobile_top);
    const dispatch = useDispatch();

    function openModal() {
       dispatch( allActions.ModalPopup.showPopupByPopupName({ popupname:mobile_top.popupname}));
    }

    if(mobile_top.popupname){
        TopADV = () => <button onClick={() => openModal()}><div dangerouslySetInnerHTML={{__html: mobile_top.data}} /></button>
     }else{
        TopADV = () => <div dangerouslySetInnerHTML={{__html: mobile_top.data}} />
     }

    return (
    <>
    <div className="mobile-top-ads-section mobile-screen-show">

        <TopADV />

        {/* <ModalPopup modalIsOpen={modalIsOpen} whichModal={mobile_top.popup} onCloseModal={() => closeModal()}/> */}

    </div>
    </>
    );
}

  
  
  export default MobileTopAds;